"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareInsuranceRate = exports.getMortgageLimitError = exports.getMortgageLimit = exports.getInsuranceRate = void 0;
var MortgageError_1 = require("../states/MortgageError");
var checkIsExceedMortgageAmount = function (mortgagePercentage, insuranceTable) {
    if (insuranceTable.rate.length) {
        var lastRate = insuranceTable.rate[insuranceTable.rate.length - 1];
        if (lastRate.key < mortgagePercentage) {
            return {
                type: MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT,
                maxLoanPercent: lastRate.key
            };
        }
    }
    else {
        if (insuranceTable.basicLoanCap < mortgagePercentage) {
            return {
                type: MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT,
                maxLoanPercent: insuranceTable.basicLoanCap
            };
        }
    }
    return null;
};
var checkIsExceedTenor = function (tenor, insuranceRate) {
    var lastValue = insuranceRate.value[insuranceRate.value.length - 1];
    if (lastValue.key < tenor) {
        return {
            type: MortgageError_1.MortgageErrorType.TENOR_OVER,
            maxTenor: lastValue.key
        };
    }
    return null;
};
exports.getInsuranceRate = function (price, downpayment, tenor, table) {
    var loan = (price - downpayment);
    var percentage = price > 0 ? (loan / price) * 100 : 0;
    var _loop_1 = function (i) {
        var insurance = table[i];
        if (price > insurance.minPropertyValue && price <= insurance.maxPropertyValue) {
            if (insurance.maxLoanAmount && loan > insurance.maxLoanAmount) {
                var error = {
                    type: MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_FIX_AMOUNT,
                    maxLoanAmount: insurance.maxLoanAmount
                };
                return { value: { error: error, amount: 0 } };
            }
            else if (insurance.allowLoanAmount && loan <= insurance.allowLoanAmount) {
                return { value: { error: null, amount: 0 } };
            }
            else {
                var isExceedMortgageAmountError = checkIsExceedMortgageAmount(percentage, insurance);
                if (isExceedMortgageAmountError)
                    return { value: { error: isExceedMortgageAmountError, amount: 0 } };
                var rate = insurance.rate.find(function (r) { return percentage >= insurance.basicLoanCap && percentage <= r.key; });
                if (rate) {
                    var isExceedTenor = checkIsExceedTenor(tenor, rate);
                    if (isExceedTenor)
                        return { value: { error: isExceedTenor, amount: 0 } };
                    var value = rate.value.find(function (r) { return tenor <= r.key; });
                    return { value: {
                            error: null,
                            amount: (price - downpayment) * (value.value / 100)
                        } };
                }
                else {
                    return { value: {
                            error: null,
                            amount: 0
                        } };
                }
            }
        }
    };
    for (var i = 0; i < table.length; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return {
        error: {
            type: MortgageError_1.MortgageErrorType.NO_PLAN
        },
        amount: 0
    };
};
exports.getMortgageLimit = function (table, price, firstTime) {
    var eligibleTable = firstTime ? table : table.filter(function (it) { return !it.firstTime; });
    return eligibleTable.find(function (it) { return price <= it.propertyValueMax && price >= it.propertyValueMin; });
};
exports.getMortgageLimitError = function (limit, price, downpayment) {
    var loanAmount = price - downpayment;
    var loanPercent = (loanAmount / price) * 100;
    if (limit.maxLoanAmount && loanAmount > limit.maxLoanAmount) {
        return {
            type: MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_FIX_AMOUNT,
            maxLoanAmount: limit.maxLoanAmount
        };
    }
    if (limit.maxLoanPercent && loanPercent > limit.maxLoanPercent) {
        return {
            type: MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT,
            maxLoanPercent: limit.maxLoanPercent
        };
    }
    return null;
};
exports.compareInsuranceRate = function (price, downpayment, tenor, list, table, adValoremStampDuty) {
    var limitResult = exports.getMortgageLimit(table, price, !adValoremStampDuty);
    if (limitResult) {
        var limitError = exports.getMortgageLimitError(limitResult, price, downpayment);
        if (limitError) {
            return {
                error: limitError,
                amount: 0
            };
        }
    }
    var result = list.map(function (r) {
        return exports.getInsuranceRate(price, downpayment, tenor, r.plan);
    });
    if (adValoremStampDuty) {
        var mortgage = price - downpayment;
        if (mortgage / price > 0.9) {
            return {
                error: {
                    type: MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT,
                    maxLoanPercent: 90
                },
                amount: 0
            };
        }
    }
    var ans = result.reduce(function (previousValue, currentValue, currentIndex, array) {
        if (previousValue) {
            if (!previousValue.error && !currentValue.error) {
                if (previousValue.amount < currentValue.amount)
                    return previousValue;
            }
            else if (!previousValue.error && currentValue.error) {
                return previousValue;
            }
            else if (previousValue.error && currentValue.error) {
                return previousValue.error.type > currentValue.error.type ? previousValue : currentValue;
            }
        }
        return currentValue;
    }, {
        error: {
            type: MortgageError_1.MortgageErrorType.UNKNOWN
        },
        amount: 0
    });
    return ans;
};
